import { render, staticRenderFns } from "./FeeTab.vue?vue&type=template&id=00cd1ace&scoped=true&"
import script from "./FeeTab.vue?vue&type=script&lang=js&"
export * from "./FeeTab.vue?vue&type=script&lang=js&"
import style0 from "./FeeTab.vue?vue&type=style&index=0&id=00cd1ace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cd1ace",
  null
  
)

export default component.exports